var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headContentDetails"},[_c('div',{staticClass:"content",class:true ? 'noBanner' : 'specsContent'},[_c('Timeline',{attrs:{"campanha":_vm.campanha}}),_c('CardDiscount',{attrs:{"campanha":_vm.campanha}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }